export default __webpack_public_path__ + "static/media/3233 spice rack E top.4c381dd5.png";